module.exports = __webpack_public_path__ + "assets/img/teacher (29).cdcfbc44.png";